"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = exports.createIntlContext = void 0;
const utils_1 = require("./utils");
Object.defineProperty(exports, "createIntlContext", { enumerable: true, get: function () { return utils_1.createIntlContext; } });
const translations_1 = require("./translations");
Object.defineProperty(exports, "translations", { enumerable: true, get: function () { return translations_1.translations; } });
